import PropTypes from 'prop-types';
import React from 'react';
import Callout from '../../shared/components/Callout';
import RuleCard from './RuleCard';
import { ISSUER_COPY } from '../constants/automationRules';

// No toggle, on purpose. PaymentReview.upsert_efw_from_stripe! runs straight off the
// radar.early_fraud_warning webhook, consulting no rule and no team flag, so an issuer alert
// reaches the flagged queue whether efw_auto_refund is on or off — that rule only ever gated
// the REFUND. So a flag-only switch here would be inert: on and off would behave
// identically, which is a worse lie than no control at all.
//
// The card therefore states what already happens, and the refund callout tracks
// autoRefundAvailable so the page stops saying "coming soon" the moment it isn't. It still
// owes a real control — refund and void, or send to review — plus the safety-window select;
// that is phase-2 work here as much as on the action card.
//
// Nothing on this card is gated by the team flag, so it renders the same for every team.
const IssuerAlertCard = ({ autoRefundAvailable }) => (
  <RuleCard
    ruleType={ISSUER_COPY.ruleType}
    title={ISSUER_COPY.title}
    icon={ISSUER_COPY.icon}
    description={ISSUER_COPY.description}
    badge={ISSUER_COPY.badge}
    showToggle={false}
    footer={
      <>
        <Callout tone="info">{ISSUER_COPY.standsAlone}</Callout>
        <Callout
          tone="info"
          lead={autoRefundAvailable ? ISSUER_COPY.refundAvailableLead : ISSUER_COPY.refundLead}
          testId={autoRefundAvailable ? 'issuer-refund-available' : 'issuer-refund-coming-soon'}
        >
          {autoRefundAvailable ? ISSUER_COPY.refundAvailableBody : ISSUER_COPY.refundBody}
        </Callout>
      </>
    }
  />
);

IssuerAlertCard.propTypes = { autoRefundAvailable: PropTypes.bool };

IssuerAlertCard.defaultProps = { autoRefundAvailable: false };

export default IssuerAlertCard;
